"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserStatusSchema = exports.UserStatus = exports.UserRole = void 0;
const zod_1 = require("zod");
// TODO: Implement this on the user model
/**
 * User-related enums for the TTO application
 */
/**
 * User roles in the system
 */
var UserRole;
(function (UserRole) {
    UserRole["ADMIN"] = "ADMIN";
    UserRole["DIRECTOR"] = "DIRECTOR";
    UserRole["USER"] = "USER";
    UserRole["VIEWER"] = "VIEWER";
})(UserRole || (exports.UserRole = UserRole = {}));
/**
 * User account status
 */
var UserStatus;
(function (UserStatus) {
    UserStatus["ACTIVE"] = "ACTIVE";
    UserStatus["INVITED"] = "INVITED";
    UserStatus["DEACTIVATED"] = "DEACTIVATED";
})(UserStatus || (exports.UserStatus = UserStatus = {}));
exports.UserStatusSchema = zod_1.z.nativeEnum(UserStatus);
